class ReferencesSlider {
	constructor($el) {
		this.$el = $el;

		this.options = {
			autoPlay: true,
			pageDots: false,
			wrapAround: true,
			prevNextButtons: true,
			freeScroll: false,
			cellSelector: ".references-slider__slide",
		};

		if (this.$el.length) {
			this._createSlider();
		}

		// elements
			var $cellButtonGroup = $('.button-group--cells');
			var $cellButtons = $cellButtonGroup.find('.button');

			// update selected cellButtons
			$el.on( 'select.flickity', function() {
			$cellButtons.filter('.is-selected')
				.removeClass('is-selected');
			$cellButtons.eq($el.selectedIndex )
				.addClass('is-selected');
			});

			// select cell on button click
			$cellButtonGroup.on( 'click', '.button', function() {
			var index = $(this).index();
			$el.flickity( 'select', index );
			});
			// previous
			$('.button--previous').on( 'click', function() {
			$el.flickity('previous');
			});
			// next
			$('.button--next').on( 'click', function() {
			$el.flickity('next');
			});


	}

	_createSlider() {
		this.$el.flickity(this.options);
	}
}

export default ReferencesSlider;
